export const ItemVacio = (idPadre) => {
  return {
    id: null,
    idEstadio: idPadre,
    club: null,
    anioDesde: null,
    mesDesde: null,
    diaDesde: null,
    anioHasta: null,
    mesHasta: null,
    diaHasta: null,
  };
};

export const saveItem = (item) => {
  return {
    anioDesde: item.anioDesde,
    mesDesde: item.mesDesde,
    diaDesde: item.diaDesde,
    anioHasta: item.anioHasta,
    mesHasta: item.mesHasta,
    diaHasta: item.diaHasta,
  };
};
